<template>
    <div v-if="showAll">
        <div v-if="forManual">
            <div class="flex justify-center pb-4 px-2">
                Select the start and end date that you'd like, we've pre-selected MTD for you This report will generate
                uniquely based on the user generating it to show the points they can see.
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                <label for="start_date">Start Date</label>
                <date-time-picker id="start_date"
                                  v-model="$data._startDate"
                                  :max-date="maxDate"
                                  :min-date="minDate"
                                  :side-by-side="true"
                                  :start-date="$data._startDate"
                                  :timezone="timezone"
                                  format="MMMM DD, YYYY"
                                  view-mode="days"
                ></date-time-picker>
            </div>

            <!-- End Date -->
            <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                <label for="end_date">End Date</label>
                <date-time-picker id="end_date"
                                  v-model="$data._endDate"
                                  :max-date="maxDate"
                                  :min-date="minDate"
                                  :timezone="timezone"
                                  format="MMMM DD, YYYY"
                                  view-mode="days"
                ></date-time-picker>
            </div>
            <!-- Pass Threshold -->
            <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                <label for="pass_threshold">Pass Threshold</label>
                <input id="pass_threshold" v-model="$data._settings['passThreshold']" type="number"
                        @input="updateSettings($event, 'Pass Threshold')"/>
            </div>
            <div class="flex justify-center">
                <button class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center px-4 py-2 border
                            border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600
                            hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700
                            active:bg-blue-700"
                        @click="runReport">
                    Run Report
                </button>
            </div>
        </div>
        <div v-else
             class="">
            <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                <label for="pass_threshold">Pass Threshold</label>
                <input id="pass_threshold_template" v-model="$data._settings['passThreshold']" type="number"
                       @input="updateSettings($event, 'Pass Threshold')"/>
            </div>
            <div class="flex justify-center py-4 px-2">
                Your auto-pushed report will run on the first of the month for the previous month
                The selected group users will each get a report generated for them with the specified setting(s)
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"

import {SonicuCoreMixin} from "../../mixins/SonicuCoreMixin";

import Select2 from "../elements/select2";


export default {
    name: "ThresholdAchievementReportSettings",
    mixins: [SonicuCoreMixin],
    components: {Select2},
    props: {
        minDate: {
            type: Date,
        },
        maxDate: {
            type: Date,
        },
        startDate: {
            type: Date,
        },
        endDate: {
            type: Date,
        },
        settings: Object,
        forManual: {
            type: Boolean,
            default: true,
        },
        showAll: {
            type: Boolean,
            default: true,
        },
        timezone: {
            type: String,
            default: 'America/New_York',
        },
    },
    data() {
        return {
            _startDate: this.startDate,
            _endDate: this.endDate,
            _settings: this.settings,
        }
    },
    created() {
        if (! _.has(this.$data._settings, 'weekday')) {
            this.$data._settings['weekday'] = 1
        }
    },
    mounted() {

    },
    methods: {
        updateSettings(event, triggeringComponent = 'Unknown') {
            // Update the settings values based on the new local
            this.$emit('update:settings', this.$data._settings)
            this.$forceUpdate()
        },
        runReport() {
            this.$emit('run-report')
        },
        saveSettings() {
            this.$emit(`saveSettings`)
        },
    },
    computed: {},
    watch: {
        startDate(val, old) {
            if (val !== old) {
                this.$data._startDate = val
            }
        },
        _startDate(val, old) {
            if (val !== old) {
                this.$emit('update:startDate', this.$data._startDate)
            }
        },
        endDate(val, old) {
            if (val !== old) {
                this.$data._endDate = val
            }
        },
        _endDate(val, old) {
            if (val !== old) {
                this.$emit('update:endDate', this.$data._endDate)
            }
        },
        passThreshold(val, old) {
            if (val !== old) {
                this.$data._passThreshold = val
            }
        },
        _passThreshold(val, old) {
            if (val !== old) {
                this.$emit('update:passThreshold', this.$data._passThreshold)
            }
        },
    },
}
</script>

<style scoped>

</style>